var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"officemanagement"}},[_c('NavBarHome'),_c('br'),_c('v-container',[_c('v-row',[_c('TreeView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }